import React from 'react';

export default function BalancePage() {
  return (
    <div className="mb-coming-soon">
      <div className="mb-coming-soon-icon">💰</div>
      <div className="mb-coming-soon-text">잔고 확인</div>
      <div className="mb-coming-soon-sub">준비중입니다.</div>
    </div>
  );
}
